export default function Loading() {
  return (
    <div className="w-full h-full flex flex-col items-center justify-center min-h-screen">
      <div className="w-8 h-8 sm:w-12 sm:h-12 mb-3">
        <div className="w-8 h-8 sm:w-12 sm:h-12 border-4 border-emerald-200/50 dark:border-emerald-900 border-t-emerald-600 dark:border-t-emerald-400 rounded-full animate-spin"></div>
      </div>
      {/* <span className="text-zinc-600 dark:text-zinc-400 text-sm font-semibold mb-3">
        Loading ...
      </span> */}
    </div>
  )
}